import Actions                   from 'Redux/Actions';
import { ofType }                from 'redux-observable';
import { from }                  from 'rxjs';
import { mergeMap, catchError }  from 'rxjs/operators';
import { TEpic }                 from 'Redux/Config';
import { EventTicketRepository } from 'Domain/Repositories';
import { message }               from 'antd';

export const deleteEventTicketEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.deleteEventTicketRequest.type),
    mergeMap(action => from(EventTicketRepository.remove(action.payload.id))
      .pipe(
        mergeMap(() => {
          message.success('Event Ticket wurde erfolgreich gelöscht.');
          return from([
            Actions.deleteEventTicketSuccess({ id: action.payload.id }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.deleteEventTicketFailure(error),
          ]);
        })
      )
    ),
  );
};
